export const userLocationMarker = (color = '#FFAC06'): string =>
  `<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="14" cy="14" r="12" fill="${color}" stroke="#fff" stroke-width="4"></circle>
  </svg>`;
